import { Components, Theme } from "@mui/material";
export const MuiToggleButtonGroup: Components<
  Omit<Theme, "components">
>["MuiToggleButtonGroup"] = {
  defaultProps: {},
};
